// extracted by mini-css-extract-plugin
export default {"tagContainer":"styles_tagContainer__d15Fh","wrappedContainer":"styles_wrappedContainer__n3QsZ","hiddenCount":"styles_hiddenCount__x1dWE"};